var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalicButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99121 8.67383L4.5293 1.45508C4.65234 0.860352 4.77539 0.744141 5.87598 0.648438L5.98535 0.128906H2.21191L2.10254 0.648438C3.16211 0.744141 3.23047 0.860352 3.10742 1.45508L1.56934 8.67383C1.44629 9.26855 1.32324 9.38477 0.222656 9.48047L0.113281 10H3.88672L3.99609 9.48047C2.93652 9.38477 2.86816 9.26855 2.99121 8.67383Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicButton);
export default __webpack_public_path__ + "static/media/italicButton.823369b09e6034fdf1c85f18024394ac.svg";
export { ForwardRef as ReactComponent };